"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFActions = void 0;
var react_1 = __importDefault(require("react"));
var ActionMenu_1 = require("../../ActionMenu");
var PDFActions = function (_a) {
    var id = _a.id, inputRef = _a.inputRef, parentOnChange = _a.parentOnChange, isInRTE = _a.isInRTE;
    return (react_1.default.createElement("div", { style: __assign({}, (isInRTE ? { display: "none" } : {})) },
        react_1.default.createElement(ActionMenu_1.ActionMenu, { popOutOfOverflowHiddenParent: true, ButtonComp: "ButtonGhost", M: true, align: 'right', iconSize: 'M', actions: [
                {
                    id: "".concat(id, "_replacePDF"),
                    display: "Replace PDF",
                    onClick: function () {
                        parentOnChange(undefined);
                        inputRef.current.click();
                    },
                },
                {
                    display: "Delete",
                    onClick: function () { return parentOnChange(undefined); },
                },
            ] })));
};
exports.PDFActions = PDFActions;
